import { each, map } from 'lodash'
import GSAP from 'gsap'
import Prefix from 'prefix'

import Text from 'animations/Text'
import BigTitle from 'animations/BigTitle'
import SmallTitle from 'animations/SmallTitle'
import Parallax from 'animations/Parallax'
import Slider from 'animations/Slider'
import ImgHover from 'animations/ImgHover'
import ZoomImg from 'animations/ZoomImg'

import Button from 'animations/Button'
import AsyncLoad from 'classes/AsyncLoad'

export default class Page {
  constructor({ element, elements, id }) {
    this.selector = element

    this.selectorChildren = {
      ...elements,
      // animationsBigTitle: '[data-animation="big-title"]',
      // animationsSmallTitle: '[data-animation="small-title"]',
      // animationsTexts: '[data-animation="text"]',
      // animationsParallax: '[data-animation="parallax"]',
      // animationsSlider: '[data-animation="slider"]',
      // animationsImgHover: '[data-animation="img-hover"]',
      animationsButton: '[data-animation="button"]',
      animationsZoomImg: '[data-animation="img-zoom"]',

      preloaders: '[data-src]'
    }

    this.id = id

    this.transformPrefix = Prefix('transform')

    this.onMouseWheelEvent = this.easeScroll.bind(this)
  }

  create() {
    this.element = document.querySelector(this.selector)

    this.elements = {}

    this.scroll = {
      current: 0,
      target: 0,
      last: 0,
      limit: 0,
      smoothness: 8 /* The Higher the less smooth it is */
    }

    this.scroll.smoothness = this.scroll.smoothness / 100

    this.body = document.body
    this.html = document.documentElement
    this.main = document.querySelector('.wrapper')
    this.header = document.querySelector('.header')
    this.nav = document.querySelector('.menu')
    this.menuButton = document.querySelector('.menu_button')
    this.availability = document.querySelector('.availability')

    each(this.selectorChildren, (entry, key) => {
      if (entry instanceof window.HTMLElement || entry instanceof window.NodeList || Array.isArray(entry)) {
        this.elements[key] = entry
      } else {
        this.elements[key] = document.querySelectorAll(entry)

        if (this.elements[key].length === 0) {
          this.elements[key] = null
        } else if (this.elements[key].length === 1) {
          this.elements[key] = document.querySelector(entry)
        }
      }
    })

    this.createAsyncLoader()
    this.createAnimations()
    this.createUI()
    this.createFn()
  }

  createAsyncLoader() {
    map(this.elements.preloaders, element => {
      return new AsyncLoad({ element })
    })
  }

  createFn() {
    if (this.pageFn) {
      this.pageFn()
    }
  }

  createUI() {
    if (this.elements.animationsButton) {
      return new Button()
    }
  }

  createAnimations() {
    this.animations = []

    if (this.elements.animationsZoomImg) {
      this.animationsZoomImg = [
        new ZoomImg({
          element: this.elements.animationsZoomImg
        })
      ]

      this.animations.push(...this.animationsZoomImg)
    }
  }

  show() {
    this.html.scrollTo(0, 0)

    this.scroll.limit = this.main.clientHeight + 'px'
    this.body.style.height = this.scroll.limit

    return new Promise(resolve => {
      this.animationIn = GSAP.timeline()

      this.animationIn.to(this.element, {
        autoAlpha: 1,
        duration: 1.5,
        ease: 'power4.out'
      }).to(this.header, {
        translateY: '0',
        ease: 'expo.out',
        autoAlpha: 1,
        duration: 0.5
      }, '-=1')

      this.animationIn.call(_ => {
        this.addEventListeners()
        this.onResize()
        resolve()
      })

      this.body.style.overflow = 'auto'
    })
  }

  hide() {
    return new Promise(resolve => {
      this.removeEventListeners()

      this.animationOut = GSAP.timeline()

      this.animationOut.to(this.element, {
        autoAlpha: 0,
        duration: 1,
        delay: 0.25,
        ease: 'power4.inOut',
        onComplete: resolve
      })
    })
  }

  easeScroll() {
    this.scroll.target = window.scrollY
  }

  update() {
    this.scroll.current = GSAP.utils.interpolate(this.scroll.current, this.scroll.target, this.scroll.smoothness)
    this.scroll.target = Math.floor(this.scroll.target * 100) / 100

    if (this.scroll.current < 0.01) {
      this.scroll.current = 0
    }

    if (window.innerWidth > 830) {
      this.main.style[this.transformPrefix] = `translateY(-${this.scroll.current}px)`
    }
  }

  addEventListeners() {
    window.addEventListener('scroll', this.onMouseWheelEvent)
  }

  removeEventListeners() {

  }

  onResize() {
    this.scroll.limit = this.main.clientHeight + 'px'
    this.body.style.height = this.scroll.limit

    this.main.style[this.transformPrefix] = `translateY(-${this.scroll.current}px)`

    this.easeScroll()

    each(this.animationsTitles, animation => animation.onResize())
  }
}
